import React from 'react';

import { AnchorList } from './AnchorList';

/**
 * 一覧表示設定メニュー
 */
export class ListSettingsNaviList extends React.Component {
  state = {
    pageName: '',
    propsState: Object.create(null),
  };

  render() {
    return (
      <React.Fragment>
        <ul className='contruction-navi-list'>
          <AnchorList
            label={'作業予定・実績一覧'}
            isSelected={true}
            onClick={() => {}} // TO DO
          />
        </ul>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/list/ListSettingsNaviList.jsx